import { CONFLUENCE_BASE_URL } from '../config';

/**
 * The Confluence page a record was extracted from.
 *
 * **`viewpage.action?pageId=` rather than the modern
 * `/spaces/<key>/pages/<id>` form**, because a record carries the page id and
 * not the space key. Confluence Cloud still serves the legacy URL and redirects
 * it to the canonical one, so the reader lands in the same place and we do not
 * have to denormalise a space key onto every record to build a link.
 */
export const confluencePageUrl = (confluencePageId: string): string =>
  `${CONFLUENCE_BASE_URL}/pages/viewpage.action?pageId=${encodeURIComponent(confluencePageId)}`;
